import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../services/setupInterceptors";
import SessionService from "../services/SessionService";
import { mergeLocalCartOnLogin } from "./cart";
import { mergeLocalWishlistOnLogin } from "./wishlist";

export const requestLoginOtp = createAsyncThunk(
  "auth/requestLoginOtp",
  async (mobile, { rejectWithValue }) => {
    try {
      const { data } = await axiosClient.post(`auth/request-mobile-otp?mobile=${mobile}`,{});
      return data.message || "OTP sent successfully";
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to send OTP");
    }
  }
);

export const validateOtpLogin = createAsyncThunk(
  "auth/validateOtpLogin",
  async ({ mobile, otp }, { dispatch, rejectWithValue, getState }) => {
    try {
      const { data } = await axiosClient.post(`auth/login-mobile-otp?mobile=${mobile}&otp=${otp}`,{});

      SessionService.setSession({
        accessToken: data.data.access_token,
        refreshToken: data.data.refresh_token,
        user: data.data.user,
      });

      const { items } = getState().cart;
      if (items?.length > 0) {
        await dispatch(mergeLocalCartOnLogin());
      }

      const {items : wishlistItems} = getState().wishlist;
      if(wishlistItems?.length > 0){
        await dispatch(mergeLocalWishlistOnLogin())
      }

      return {
        user: data.data.user,
        accessToken: data.data.access_token,
        refreshToken: data.data.refresh_token,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Invalid OTP");
    }
  }
);


const authSlice = createSlice({
  name: "auth",
  initialState: {
 userLoggedIn: sessionStorage.getItem("app_session"),
 
  user: SessionService.user,
  accessToken: SessionService.accessToken,
  refreshToken: SessionService.refreshToken,
  status: "idle",
  otpSent: false,
  email: "",
  error: null,
},

  reducers: {
    logout(state) {
      console.log("logout");
      SessionService.clear();
      sessionStorage.clear()
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.userLoggedIn = false;
      state.status = "idle";
      state.error = null;
      state.otpSent = false;
      state.email = "";
    },
    openLoginModal(state) {
      state.showLoginModal = true;
    },
    closeLoginModal(state) {
      state.showLoginModal = false;
      state.otpSent = false;
      state.email = "";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestLoginOtp.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(requestLoginOtp.fulfilled, (state, action) => {
        state.status = "otp_sent";
        state.otpSent = true;
      })
      .addCase(requestLoginOtp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(validateOtpLogin.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(validateOtpLogin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload.user;
        state.accessToken = action.payload.accessToken;
        state.refreshToken = action.payload.refreshToken;
        state.userLoggedIn = true;
        state.otpSent = false;
      })
      .addCase(validateOtpLogin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { logout, openLoginModal, closeLoginModal } = authSlice.actions;
export default authSlice.reducer;
